import styled from 'styled-components';
import { AiOutlineButton } from '../ai';
import { NotificationBanner } from '../notificationBanner';

/** Keep each subscription notice and its follow-up actions together inside a chat message. */
export const AgentRequirementControls = styled.fieldset`
    display: flex;
    flex-direction: column;
    gap: 12px;
    border: 0;
    padding: 0;
    margin: 16px 0 0;
    min-width: 0;

    ${NotificationBanner} {
        margin-bottom: 0;
    }

    ${AiOutlineButton} {
        align-self: flex-start;
        max-width: 100%;
        min-height: 36px;
        height: auto;
        padding: 8px 14px;
        line-height: 20px;
        white-space: normal;
        text-align: center;
    }
`;
